import { render, staticRenderFns } from "./otherHeader.vue?vue&type=template&id=5a5b47d4"
import script from "./otherHeader.vue?vue&type=script&lang=js"
export * from "./otherHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports